import { MenuItems } from '@menu-lib/components/AppLayout/MainMenu/menuItems';
import { MenuItemRegistry } from '@menu-lib/components/AppLayout/MainMenu/menuRegistry';
import { type EnvironmentSettings, type LinkItem } from '@menu-lib/components/AppLayout/types';

MenuItemRegistry.register(MenuItems.Overvoer, {
  isVisible: (settings: EnvironmentSettings) => settings.isInterneGebruiker,
  create: (): LinkItem => ({
    itemtype: 'link',
    menuItem: MenuItems.Overvoer,
    title: 'Overvoer',
    url: '/app/aanvraag/recente-activiteiten/overvoer',
    iconclass: 'far fa-file-import',
    target: '_top',
  }),
});
